import dynamic from "next/dynamic";
import SideBySideWithBackgroundHeroConfig from "./side-by-side-with-background-hero-config";
const SideBySideWithBackgroundHeroComponent = dynamic(()=>import("./side-by-side-with-background-hero-component"));
export default {
    SideBySideWithBackgroundHeroComponent,
    SideBySideWithBackgroundHeroConfig
};
